document.addEventListener("DOMContentLoaded", function () {
  // Observer for removing tabindex from Flickity slider containers
  const flickityObserver = new MutationObserver(() => {
    const flickityDivs = document.querySelectorAll('#AnnouncementSlider, .testimonials-slider, .product-slideshow');
    flickityDivs.forEach(el => {
      el.removeAttribute("tabindex");
    });
  });
  flickityObserver.observe(document.body, { childList: true, subtree: true });

  // Observer for setting aria-label, role, and tabindex on flickity page dots
  const dotsObserver = new MutationObserver(() => {
    document.querySelectorAll('.flickity-page-dots li').forEach((dot, index) => {
      dot.setAttribute('aria-label', `Go to slide ${index + 1}`);
      dot.setAttribute('role', 'button');
      dot.setAttribute('tabindex', '0');
      if (dot.innerHTML.trim() === '') {
        const span = document.createElement('span');
        span.className = 'sr-only';
        span.textContent = `Go to slide ${index + 1}`;
        dot.appendChild(span);
      }
    });
  });
  dotsObserver.observe(document.body, { childList: true, subtree: true });

  // Observer for removing tabindex on the needsclick teaser
  const teaserObserver = new MutationObserver(() => {
    const teaserDiv = document.querySelector('div.needsclick');
    if (teaserDiv) {
      teaserDiv.removeAttribute('tabindex');
      teaserObserver.disconnect(); // done
    }
  });
  teaserObserver.observe(document.body, { childList: true, subtree: true });

  // Immediately fix aria-labels on photo zoom buttons (no observer needed)
  document.querySelectorAll('button.js-photoswipe__zoom').forEach((btn) => {
    if (!btn.hasAttribute('aria-label')) {
      btn.setAttribute('aria-label', 'Zoom image');
    }
  });
});
